<template>
  <div class="app-container">
    <!--form 组件-->
    <eForm ref="form" :is-add="isAdd" :sup-this="supThis"/>
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dataTableSearch">
        <template v-slot:next>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="subAdd">新增
          </el-button>
        </template>
      </dynamic-search>
      <div class="data-table-box">
      <edit-data-table
        :loading="loading"
        :head="tableHead"
        rowKeyField="id"
        ref="editTable"
        show-number
        :data.sync="list"
        :total="total"
        :offset="offset"
        :page="page"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange">
        <template v-slot:toolbar="{row}">
          <el-button
            size="mini"
            type="text"
            :icon="row.status?'el-icon-video-pause' : 'el-icon-video-play'"
            @click="subEditPause(row)" />
          <el-button size="mini" type="text" icon="el-icon-edit" @click="edit(row)"></el-button>
          <el-popover :ref="row.id+1" placement="top" width="180">
            <p>确定要单独执行一次任务吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[row.id+1].doClose()">
                取消
              </el-button>
              <el-button
                :loading="implementLoading"
                type="primary"
                size="mini"
                @click="subImplement(row.id)">确定
              </el-button>
            </div>
            <el-button size="mini" type="text" icon="el-icon-refresh" slot="reference" title="执行一次" />
          </el-popover>
          <el-popover :ref="row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[row.id].doClose()">
                取消
              </el-button>
              <el-button
                :loading="delLoading"
                type="primary"
                size="mini"
                @click="subDelete(row.id)">确定
              </el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference" class="table-del-btn"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </div>
    </el-card>
  </div>
</template>

<script>
  import "@/components/EditDataTable"
  import DynamicSearch from '@/components/DynamicSearch/index.vue'
  import DataTableMixin from '@/mixins/DataTableMixin'
  import {del, enableOrDisable,implement} from '@/api/monitor/task'
  import eForm from './form'
  import {deepClone} from '@/utils/index'

  export default {
    name: "Task",
    mixins: [DataTableMixin],
    components: {
      DynamicSearch,
      eForm
    },
    data() {
      return {
        delLoading: false,
        implementLoading: false,
        isAdd: false,
        supThis: this,
        tableHead: [
          {
            label: '任务名称',
            prop: 'name',
            query: {
              type: 'input'
            },
          }, {
            label: 'Bean名称',
            prop: 'beanName'
          }, {
            label: '执行方法名称',
            prop: 'methodName',
          }, {
            label: '方法参数',
            prop: 'params',
            width: 100
          }, {
            label: 'Cron表达式',
            prop: 'cronExpression',
            width: 100
          }, {
            label: '任务状态',
            prop: 'status',
            width: 100,
            formatter: (val) => {
              return val === 1 ? '运行中' : '暂停'
            }
          }, {
            label: '创建时间',
            prop: 'created',
            width: 160,
            sortable: true,
          },
        ]
      }
    },
    created() {
      this.$nextTick(() => {
        this.dataTableInit()
      })
    },
    methods: {
      dataTableBeforeInit() {
        this._url = '/sysScheduledTaskConfiguration'
        const params = {page: this.page, size: this.offset}
        this._params = Object.assign(params, this._query)
        return true
      },
      handleDeletes(rows) {
        rows.forEach(element => {
          this.subDelete(element.id)
        });
      },
      subAdd() {
        this.$refs.form.form = {sort: 999}
        this.$refs.form.dialog = true;
        this.isAdd = true
      },
      subDelete(id) {
        this.delLoading = true
        del(encodeURIComponent(id)).then(res => {
          this.delLoading = false
          this.$refs[id].doClose()
          this.dleTableChangePage()
          this.dataTableInit()
          this.$notify({
            title: '删除成功',
            type: 'success',
            duration: 2500
          })
        }).catch(err => {
          this.delLoading = false
          this.$refs[id].doClose()
          console.log(err)
        })
      },
      subImplement(id) {
        this.implementLoading = true;
        implement(id).then(res => {
          this.implementLoading = false;
          this.$refs[id + 1].doClose();
          if (res.code === 200) {
            this.$notify({
              title: '执行成功',
              message: res.msg,
              type: 'success',
              duration: 2500
            })
          } else {
             this.$notify({
              title: '执行失败',
              message: res.msg,
              type: 'error',
              duration: 2500
            })
          }
        })
      },
      subEditPause(data) {
        const {id, status} = data
        enableOrDisable(id, status === 1 ? 0 : 1).then(() => {
          this.$notify({
            title: status === 1 ? '暂停成功' : '启动成功',
            type: 'success',
            duration: 2500
          })
          this.dataTableInit()
        })
      },
      edit(data) {
        this.isAdd = false
        const _this = this.$refs.form
        _this.form = deepClone(data)
        _this.dialog = true
      },
    }
  }
</script>

<style scoped lang="scss">

  .tree-container-scroll {
    padding-top: 15px;
    height: 400px;

    /deep/ .el-scrollbar__wrap {
      overflow-x: auto;
    }
  }

  /deep/ .splitter-pane-resizer {
    background-color: #ffffff;
  }
</style>
